import React, { useState, useEffect } from "react";
// eslint-disable-next-line no-unused-vars
import { Col, Container, Row, Button, Alert } from "react-bootstrap";
import "../../Style.css";
import List from "../../components/listing/List";
import BreadCrumb from "../../components/breadcrumb/BreadCrumb";
import Api from "../../components/api/Api";
import { useSelector } from "react-redux";
import axios from "axios";
import Notification, {
  showToast,
} from "../../../components/common/notification/Notification";
import Tr from "../../components/tr/Tr";


const PropertyStages = () => {
  const loggedInUser = useSelector((state) => state.auth.user);
  // eslint-disable-next-line no-unused-vars
  const userId = loggedInUser?.userDetails?.id;
  const token = loggedInUser?.token;
  const serviceApi = Api({
    url: "property/stageList",
  });

  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  
  const handleDelete = async (itemId) => {
      console.log("itemId");
      console.log(itemId);
    try {
      const response = await axios.delete(
        `${baseUrl}/property/deleteStage/${itemId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(response);
      if (response.data.statusType === "SUCCESS") {
        setData(data.filter((item) => item.id !== itemId));
        showToast("Property Status deleted successfully", {
          type: "success",
        });
      } else {
        console.error(
          "Error 'deleting' item. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error 'deleting' item:", error);
    }
  };

  const [data, setData] = useState([]);
  const columns = [
    { displayName: "S.No.", render: (item, index) => index + 1 },
    { displayName: "Name", key: "name" },
    { displayName: "Description", key: "description" },
  ];
  const fetchPropertyData = async (pageNumber = 1) => {
    try {
      const responseData = await serviceApi.fetchData(pageNumber);
      setData(responseData.data.propertyStages);
      setTotalPages(responseData.data.totalPage);
      console.log(responseData.data)
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    fetchPropertyData(currentPage);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const initialValues = {};
  const breadcrumbItems = [
    { label: "", link: "/admin", icon: "fa-solid fa-house" },
    { label: "Master", link: "/user" },
    { label: "Property Stages", link: "/property-stages", active: true },
  ];
  return (
    <>
      <Notification />
      <div className="content-body2">
        <Container>
          <BreadCrumb items={breadcrumbItems} />
 
          <Row>
            <Col lg={12} md={12} sm={12}>
              {data?.length === 0 ? (
                <Tr
                  columns={columns}
                  initialValues={initialValues}
                  title="No Property Stages Found"
                  buttonName="Create"
                  btnLink="property-stages/add-propertyStages"
                  titleHeader="Property Stages"
                />
              ) : (
                <List
                  title="Property Stages"
                  data={data}
                  columns={columns}
                  button="Create"
                  route="property-stages"
                  to="add-propertyStages"
                  handleDelete={handleDelete}
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              )}
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default PropertyStages;
